<template>
  <div
    class="faq bg-white wc-lg"
    :class="{ business: business, bg_gray: business }"
  >
    <div class="faq__wrapper">
      <div class="faq__ttl-wrapper  container">
        <h2
          class="f-24 bold uppercase"
          :class="{ f_light_purple: purple_title }"
        >
          {{ _.get(this.content, "conf.header.title") }}
        </h2>
      </div>

      <FaqItem
        v-for="(item, index) in _.get(content, 'data.list')"
        :key="index"
        :question="item.title"
        :answer="item.answer"
      />
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import FaqItem from "@/components/modules/FaqItem.vue";
export default {
  props: ["contentData", "tags"],
  mixins: [resize_handler],
  components: { FaqItem },
  computed: {
    content() {
      return this.contentData;
    },
    business() {
      let d = _.get(this.contentData, "conf.conf");
      d = d.includes("business");
      return d;
    },
    purple_title() {
      let d = _.get(this.contentData, "conf.conf");
      d = d.includes("purple_title");
      return d;
    }
  },
  mounted() {}
};
</script>

<style></style>
